import Header from "./Header";

export default function Banner(props) {
    
    return <>
        <div 
        style={{ backgroundImage: `url(${props.bg})` }} 
        className={`bannerWrap ${props.clsName ? props.clsName : ''}`}>
            <Header />
            <div className='container' >
             { props.children} 
            </div>
        </div>
    </>
}